var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStepbystep = function SvgStepbystep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M56 28c0 15.464-12.536 28-28 28S0 43.464 0 28 12.536 0 28 0s28 12.536 28 28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EAEE",
    d: "M25.587 16.91c-9.041 0-16.374 5.844-16.374 13.048 0 3.067 1.351 5.786 3.549 8.113.885.937 1.327 2.27 1.327 3.662a5.73 5.73 0 0 1-1.687 4.058 8.43 8.43 0 0 0 5.979-4.113c2.174.852 4.617 1.328 7.206 1.328 9.044 0 16.375-5.842 16.375-13.048 0-7.204-7.331-13.049-16.375-13.049"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD3DA",
    d: "M35.95 19.856c1.086 1.745 1.7 3.712 1.7 5.791 0 7.206-7.33 13.048-16.374 13.048-3.909 0-7.491-1.09-10.308-2.91.505.798 1.11 1.562 1.793 2.286.886.937 1.328 2.27 1.328 3.663a5.73 5.73 0 0 1-1.687 4.058 8.43 8.43 0 0 0 5.979-4.114c2.174.851 4.617 1.329 7.206 1.329 9.044 0 16.375-5.843 16.375-13.05 0-4.072-2.34-7.706-6.012-10.101"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAB5BD",
    d: "M22.003 29.95a1.155 1.155 0 1 1-1.156-1.155 1.16 1.16 0 0 1 1.156 1.155M26.745 29.95a1.159 1.159 0 0 1-2.315 0 1.159 1.159 0 0 1 2.315 0M31.486 29.95c0 .639-.52 1.157-1.158 1.157a1.16 1.16 0 0 1-1.156-1.157c0-.636.52-1.155 1.156-1.155.637 0 1.158.52 1.158 1.155"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37517E",
    d: "M48.955 22.199H29.512l-3.143-7.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B9FF",
    d: "M48.955 22.199H29.512l4.2-11.99z"
  }))));
};
export default SvgStepbystep;